import { Routes } from '@axa-fr-axion/router';
import { ScrollToTopOfLayout } from '@axa-fr-axion/layouts';
import '@axafr-btc-ds/colors/theme-vars.css';
import { NavigationPath } from 'interfaces';
import { Stepper } from '@axa-fr-axion/stepper';
import { useApplication } from 'stores/application/application';
import { useFolder } from '@axa-fr-axion/user-journey-services';
import { RenderIf } from 'components';
import { LoaderPage } from '@axa-fr-axion/loader';
import { CreateRoutesComponents } from 'App.router.utils';
import { DataDomeHandler } from 'components/datadome-handler/DatadomeHandler';
import { isDatadomeBlocked } from '@axa-fr-axion/http';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
// Step 3 - Contact information

function App(): JSX.Element {
    const {
        _options,
        preset,
        step,
        handleTechnicalError,
        handleInitializationSuccess,
    } = useApplication();

    const { isLoading, error } = useFolder(
        {
            origine: _options.origine ?? {},
            proprietes: _options.proprietes,
        },
        {
            onSuccess: handleInitializationSuccess,
            onTechnicalError: handleTechnicalError,
            isEnabled: step !== 'Scenarios',
        },
    );

    return (
        <>
            <RenderIf value={ !isLoading || step === 'Scenarios' } elseComponent={ <LoaderPage title="Veuillez patienter, nous chargeons l'étape initiale." /> }>
                <ScrollToTopOfLayout path={ step }>
                    <div className='stepperLayout'>
                        <Stepper<NavigationPath>
                            steps={ preset.stepper.steps }
                            data={ preset.stepper.data }
                            path={ step }
                        />
                    </div>
                </ScrollToTopOfLayout>
                <section aria-label="Parcours QQ Auto">
                    <Routes<NavigationPath>>
                        { CreateRoutesComponents() }
                    </Routes>
                </section>
            </RenderIf>
            <RenderIf value={ process.env.NODE_ENV === 'development' && isDatadomeBlocked(error) && !!_options.config?.isMockEnabled }>
                <DataDomeHandler />
            </RenderIf>
            <ReactQueryDevtools initialIsOpen={ false } />
        </>
    );
}

export default App;
